import React from 'react';

import PropTypes from 'prop-types';

import {
    MarkdownContent,
    Typography,
    Section,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import HotelsCard from '../HotelsCard';

import styles from './HotelsSection.scss';

const propTypes = {
    hotelsContent: PropTypes.arrayOf(PropTypes.shape({
        description: PropTypes.string,
        title: PropTypes.string,
    })),
    namespace: PropTypes.string,
    sectionTitle: PropTypes.string,
};

const defaultProps = {
    hotelsContent: [],
    namespace: '',
    sectionTitle: '',
};

const HotelsSection = (props) => {
    const {
        t,
        namespace,
        sectionTitle,
        sectionDescription,
        hotelsContent = [],
    } = props;
    return (
        <>
            <Section id="hotels-section">
                <Typography
                    classes={{ root: styles.heading }}
                    component="h2"
                    variant="h3"
                >
                    {sectionTitle}
                </Typography>
                <Typography>
                    {sectionDescription}
                </Typography>
                <div className={styles.hotelsBox}>
                    {hotelsContent.map(({ title, description }) => (
                        <HotelsCard
                            description={
                                <MarkdownContent externalLinks>
                                    {description}
                                </MarkdownContent>
                            }
                            key={title}
                            title={title}
                        />
                    ))}
                </div>
            </Section>
        </>
    );
};

HotelsSection.propTypes = propTypes;
HotelsSection.defaultProps = defaultProps;

export { HotelsSection };
export default localize(HotelsSection);
